/**
 * Created by pajicv on 10/5/18.
 */

import { compose } from 'redux';
import { connect } from 'react-redux';
import { firebaseConnect, populate } from 'react-redux-firebase';
import Task from './Task';
import { spinnerWhileLoading } from '../../utils/components';

const populateProjectMembers = [{
  child: 'members',
  root: 'users',
  populateByKey: true
}];

const populateTaskSubTasks = [
  {
    child: 'subTasks',
    root: 'subTasks'
  }, {
    child: 'cycle',
    root: 'cycles'
  }];

const enhance = compose(
  firebaseConnect((props) => {
    const { projectId, taskId } = props;
    return [{
      path: `projects/${projectId}`,
      populates: populateProjectMembers
    }, {
      path: `tasks/${taskId}`,
      populates: populateTaskSubTasks
    }, {
      path: 'subTasks', queryParams: ['orderByChild=task', `equalTo=${taskId}`]
    }];
  }),
  connect(
    (state, props) => {
      const { projectId, taskId, subTaskAssigned } = props;
      return ({
        project: populate(state.firebase, `projects/${projectId}`, populateProjectMembers),
        task: populate(state.firebase, `tasks/${taskId}`, []),
        auth: state.firebase.auth,
        subTasks: state.firebase.ordered.subTasks,
        taskId,
        projectId,
        subTaskAssigned
      });
    }
  ),
  spinnerWhileLoading(['project', 'task', 'subTasks'])
);

export default enhance(Task);



// WEBPACK FOOTER //
// ./src/components/Tasks/Task.enhancer.js